import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const Protected = () => {
  const isAuthenticated = !!localStorage.getItem("token");
  return isAuthenticated ? <Outlet /> : <Navigate to="/sign-in" replace />;
};

export default Protected;
